import React from 'react';

interface childProps {
    msg: string;
    type: string;
    clasName?: string;
    zIndex?: number; // zIndex ajouté comme prop optionnelle
}

const Alert = (props: childProps) => {
    const { msg, type, clasName, zIndex } = props;

    return (
        <div
            style={{ zIndex: zIndex }} // valeur par défaut 2000
            className={`alert alert-${type} alert-dismissible fade show my-2 ${clasName}`}
            role="alert"
        >
            <strong>{msg}</strong>
            <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
            ></button>
        </div>
    );
};

export default Alert;
